import React from "react";
import { useState } from "react";
import { CommunityData } from "./Data";
import CommunityCard from "./CommunityCard";

const Community = () => {
	const [toggle, setToggle] = useState();
	const changeToggle = (index) => {
		setToggle(index);
		// console.log(index)
	};

	return (
		<>
			<div className="flex max-w-[1200px]  mx-auto justify-center items-start  flex-col xl:p-0 p-5">
				<div className="xl:w-1/2">
					<h1 className="sm:w-[360px] text-[1.875rem] font-[700]  leading-0 ">
						Enjoy a Web3 experience powered by community
					</h1>
					<p className=" text-[1.125rem]  my-5  ">
						Join our vibrant and diverse community to learn about the power of
						self-custody, crypto, and Web3
					</p>
				</div>
				<div className="w-full overflow-auto no-scrollbar">
					<div className="w-[1200px] grid grid-cols-4  gap-5 my-5  ">
						{CommunityData.map((item, index) => (
							<CommunityCard key={index} data={item} />
						))}
					</div>
				</div>

				<button
					className={`sm:w-max w-full flex justify-center items-center blue  relative serviceCardAnimation  overflow-hidden rounded-full my-10 duration-500${
						toggle === 1 ? "text-black" : "text-white"
					}`}
					onMouseOver={() => changeToggle(1)}
					onMouseOut={() => changeToggle(0)}
				>
					<h5 className="w-full h-full bg-sky-500 z-0 rounded-full"></h5>
					<h1
						className={`z-50 bg-transparent text-[0.9375rem] px-[2.5rem] py-[0.75rem] font-medium ${
							toggle === 1 ? "text-black" : "text-white"
						}`}

						onClick={()=>{
							window.open(
							  "https://t.me/trinetwallet",
							  "_blank"
							)
							
						  }}
					>
						Join our community on Telegram
					</h1>
				</button>
			</div>
		</>
	);
};

export default Community;
